export default __webpack_public_path__ + "static/media/KZ.Т.12.2505.8853d639.svg";